import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, Field, SubmissionError } from 'redux-form'
import { SubmitButton } from 'LiveBoard/components/shared/SubmitButton'
import isEmpty from 'lodash/isEmpty'
import { validate } from './validator'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'

import './style.css.scss'

const ShareEmailForm = ({
  themeColorHex,
  onSubmit,
  reset,
  handleSubmit,
  error,
  getTranslation
}) => {

   const submitHandler = (values) => {
    const error = validate(values)
    if(!isEmpty(error)) {
      throw new SubmissionError({ _error: error.email[0] })
    }
    onSubmit(values)
    reset()
  }

  return (
    <div className='share-form-container'>
      <form className="share-form" onSubmit={handleSubmit(submitHandler)}>
        <Field
          className={`share-input ${!!error ? 'error' : ''}`}
          name="email"
          component="input"
          type="email"
          placeholder={getTranslation(TRANSLATION_VALUE_KEYS.email)} />
      </form>
      { !!error && <span className="error">{error}</span> }
      <SubmitButton
        onClick={handleSubmit(submitHandler)}
        themeColorHex={themeColorHex} />
    </div>
  )
}

ShareEmailForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  error: PropTypes.string
}

export default reduxForm({ form: 'emailShare' })(
  withTranslation(TRANSLATION_KEYS.shareEmail)(ShareEmailForm)
)